import { useQuery } from '@tanstack/react-query'
import { fetchDocuments, isDocumentsApiAvailable } from '@/services/documents/documentsApi'
import { isProcessing } from '@/services/documents/documentMappers'
import { workspaceScopedKey } from '@/services/workspaces/workspaceQueryKeys.js'
import { getActiveWorkspaceId } from '@/store/workspaceStore'

export function documentsQueryKey() {
  return workspaceScopedKey(['do-chat', 'documents'])
}

export function useDocuments() {
  const workspaceId = getActiveWorkspaceId()
  return useQuery({
    queryKey: documentsQueryKey(),
    queryFn: ({ signal }) => fetchDocuments({ signal }),
    enabled: isDocumentsApiAvailable() && Boolean(workspaceId),
    retry: false,
    refetchInterval: (query) =>
      (query.state.data ?? []).some(isProcessing) ? 2500 : false,
  })
}
